import React from 'react';
import RichTextEditor from './RichTextEditor';
import { useFetchNotificationOptions } from '../../../Hooks/Notification';
import styles from './RichTextEditorField.module.css';
import './styles.css';

// Preserve the existing form field contract: onChange(name, html).
const RichTextEditorField = ({ name, value, onChange, errors, touched, label, border = true, minHeight = 320, maxHeight }) => {
  const { data: notificationOptions } = useFetchNotificationOptions();
  return (
    <div className={styles.field}>
      {label && <h4 className={styles.label}>{label}</h4>}
      {errors && touched && <span className={styles.error} role='alert'>{errors}</span>}
      <RichTextEditor
        notificationOptions={notificationOptions?.data || []}
        className={border ? undefined : styles.borderless}
        value={value || ''}
        onChange={(html) => onChange?.(name, html)}
        minHeight={minHeight}
        maxHeight={maxHeight}
        maxCharacters={Infinity}
        allowAttachments={false}
        debounceMs={0}
      />
    </div>
  );
};

export default RichTextEditorField;
